import { createElement } from 'react';
import { BadgePlaceholders, Badges } from '../Foundation/Badges';
export const renderBadge = badge => badge && !!Badges[badge] ? /*#__PURE__*/createElement(Badges[badge]) : undefined;
export const renderLockedBadge = category => {
  return BadgePlaceholders[category] ? /*#__PURE__*/createElement(BadgePlaceholders[category]) : undefined;
};